import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconClose } from 'src/assets/icons/IconClose';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { Loader } from 'src/components/Loader';
import { ResourceThumbnailTooltip } from 'src/components/ResourceThumbnailTooltip';
import { ResourceTypeIcon } from 'src/components/ResourceTypeIcon';
import { isResourceUploadId, RESOURCE_CONTENT_TYPE } from 'src/data/performance';
import { PROMPT_ACTION } from 'src/data/prompt';

import { getUploadingResourceTooltip } from '../../../../lib';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  resource: PropTypes.shape().isRequired,
  index: PropTypes.number,
  onAction: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
  index: 0,
};

export const AttachmentOther = ({ className, resource, index, onAction }) => {
  const styles = useStyles();

  const label = resource?.label || resource?.name;

  const handleTooltipClick = useCallback(() => {
    onAction(PROMPT_ACTION.openResourceInNewTab, { resource });
  }, [resource, onAction]);

  const handleRemoveClick = useCallback(() => {
    onAction(PROMPT_ACTION.removeFileResource, {
      id: resource.id,
      contentType: resource.contentType,
      label: resource.label || resource.name,
      index,
    });
  }, [onAction, resource, index]);

  const content = (
    <div className={cx(styles.root, className)}>
      <ResourceTypeIcon
        className={styles.icon}
        type={resource.contentType || resource.type || RESOURCE_CONTENT_TYPE.document} // TODO: clear confusion around "type"/"contentType" - it should be contentType everywhere, as this is the field name of Resource entity on BE
        fileType={resource.file?.fileType}
        small
      />

      <div className={styles.label}>{label}</div>

      {isResourceUploadId(resource.id) && (
        <Loader
          className={styles.loader}
          size={16}
        />
      )}

      <span>
        <IconClose
          className={styles.buttonRemove}
          onClick={handleRemoveClick}
        />
      </span>
    </div>
  );

  return isResourceUploadId(resource.id) ? (
    <CustomTooltip
      classes={{ tooltip: styles.loadingTooltip }}
      title={getUploadingResourceTooltip(resource)}
      placement="top"
      arrow
    >
      {content}
    </CustomTooltip>
  ) : (
    <ResourceThumbnailTooltip
      classes={{ tooltip: styles.documentTooltip }}
      thumbnailUrl={resource?.file?.thumbnailUrl}
      onClick={handleTooltipClick}
      label={label}
      placement="bottom-start"
    >
      {content}
    </ResourceThumbnailTooltip>
  );
};

AttachmentOther.propTypes = propTypes;
AttachmentOther.defaultProps = defaultProps;
